import { render, staticRenderFns } from "./SaSideBar.vue?vue&type=template&id=043d8c4e&"
import script from "./SaSideBar.vue?vue&type=script&lang=js&"
export * from "./SaSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports